// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__17kza","modalForm":"UpgradeEpcsModal_modalForm__3VeaI","modalFooter":"UpgradeEpcsModal_modalFooter__2AJ9Y"};